import React, { useState, useImperativeHandle, forwardRef } from 'react';
import GoogleMapReact from 'google-map-react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const isWordsIncludesVal = (words: string, val: string) =>
  words
    .toLowerCase()
    .split(' ')
    .join('')
    .includes(val.toLowerCase().split(' ')[0]);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      height: 400,
      [theme.breakpoints.up(2550)]: {
        height: 500,
      },
    },
  })
);

const Maps = forwardRef(({ asal, tujuan }: any, ref) => {
  const classes = useStyles();
  const [mapsState, setMapsState] = useState<any>({
    mapsLoaded: false,
    map: null,
    maps: null,
  });
  const [polylineState, setPolylineState] = useState<any>(null);
  const [markerState, setMarkerState] = useState<any>([]);

  useImperativeHandle(ref, () => ({
    handlePolyline() {
      if (!polylineState) {
        const KgCakung = [
          { lat: -6.155617353205415, lng: 106.8968771758425 },
          { lat: -6.156940963576456, lng: 106.8992619243078 },
          { lat: -6.158954503091677, lng: 106.90300202042175 },
          { lat: -6.165687426767811, lng: 106.91353143653474 },
          { lat: -6.1658809727171855, lng: 106.9138418906567 },
          { lat: -6.166939865669957, lng: 106.91657417472254 },
          { lat: -6.167344553331166, lng: 106.91707056905206 },
          { lat: -6.168252631837042, lng: 106.91753717972179 },
          { lat: -6.177846583745436, lng: 106.91812292488927 },
          { lat: -6.180954625727625, lng: 106.91788275740981 },
          { lat: -6.18159044007559, lng: 106.91790794454843 },
          { lat: -6.182274406933989, lng: 106.91837126958549 },
          { lat: -6.182888580498395, lng: 106.91931195976021 },
          { lat: -6.183307334803246, lng: 106.92436641432921 },
          { lat: -6.183579524912945, lng: 106.92567916855162 },
          { lat: -6.183620992715921, lng: 106.9262906652514 },
          { lat: -6.183502345769958, lng: 106.92738579709659 },
          { lat: -6.1826565033646625, lng: 106.93365566272794 },
          { lat: -6.182535721119017, lng: 106.93397764813581 },
          { lat: -6.182319364459487, lng: 106.9354553741192 },
          { lat: -6.182232123841658, lng: 106.93586604853368 },
          { lat: -6.182099518081496, lng: 106.93677163832875 },
          { lat: -6.18208206995121, lng: 106.93696469038899 },
          { lat: -6.182165820964274, lng: 106.93732973433738 },
          { lat: -6.182267020087331, lng: 106.93763510764038 },
          { lat: -6.182406605052916, lng: 106.9378948504498 },
          { lat: -6.182657857905309, lng: 106.93811247277515 },
          { lat: -6.182968434174011, lng: 106.93825638433172 },
          { lat: -6.183373229945606, lng: 106.93827042446482 },
          { lat: -6.183589011120266, lng: 106.93812701720795 },
        ];
        const KgBekasi = [
          { lat: -6.155617353205415, lng: 106.8968771758425 },
          { lat: -6.156940963576456, lng: 106.8992619243078 },
          { lat: -6.158954503091677, lng: 106.90300202042175 },
          { lat: -6.165687426767811, lng: 106.91353143653474 },
          { lat: -6.1658809727171855, lng: 106.9138418906567 },
          { lat: -6.166939865669957, lng: 106.91657417472254 },
          { lat: -6.167344553331166, lng: 106.91707056905206 },
          { lat: -6.168252631837042, lng: 106.91753717972179 },
          { lat: -6.177846583745436, lng: 106.91812292488927 },
          { lat: -6.180954625727625, lng: 106.91788275740981 },
          { lat: -6.18159044007559, lng: 106.91790794454843 },
          { lat: -6.182274406933989, lng: 106.91837126958549 },
          { lat: -6.182888580498395, lng: 106.91931195976021 },
          { lat: -6.183307334803246, lng: 106.92436641432921 },
          { lat: -6.183579524912945, lng: 106.92567916855162 },
          { lat: -6.183620992715921, lng: 106.9262906652514 },
          { lat: -6.183502345769958, lng: 106.92738579709659 },
          { lat: -6.1826565033646625, lng: 106.93365566272794 },
          { lat: -6.1824679499683715, lng: 106.93489911004757 },
          { lat: -6.182467094459695, lng: 106.93500554949635 },
          { lat: -6.182323790557231, lng: 106.9361131687125 },
          { lat: -6.182276309905656, lng: 106.93647807552632 },
          { lat: -6.1823124770997575, lng: 106.93673525614538 },
          { lat: -6.182375408387697, lng: 106.93708332150375 },
          { lat: -6.183066718889969, lng: 106.93832172332493 },
          { lat: -6.183256987679867, lng: 106.93867578024613 },
          { lat: -6.183447341739088, lng: 106.93906132708295 },
          { lat: -6.183741087927967, lng: 106.93990035820065 },
          { lat: -6.183960505985163, lng: 106.94121138014256 },
        ];
        const isKGCakung = (val: string) =>
          'kelapagading - cakung'.includes(
            val.toLowerCase().split(' ').join('')
          );

        const isKGBekasi = (val: string) =>
          'kelapagading - bekasiraya'.includes(
            val.toLowerCase().split(' ').join('')
          );
        const asalKGCakung = isKGCakung(asal);
        const tujuanKGCakung = isKGCakung(tujuan);
        let polylineData: any;
        if (asal && tujuan && asalKGCakung && tujuanKGCakung) {
          polylineData = KgCakung;
        }

        const asalKGBekasi = isKGBekasi(asal);
        const tujuanKGBekasi = isKGBekasi(tujuan);
        if (asal && tujuan && asalKGBekasi && tujuanKGBekasi) {
          polylineData = KgBekasi;
        }

        const polyline = new mapsState.maps.Polyline({
          path: polylineData,
          geodesic: false,
          strokeColor: '#00a1e1',
          strokeOpacity: 1.0,
          strokeWeight: 8,
        });
        polyline.setMap(mapsState.map);
        setPolylineState(polyline);
      }
    },

    handleMarker() {
      if (markerState[0] === undefined || !markerState.length) {
        const dataMarkers = [
          {
            name: 'CAKUNG',
            lat: -6.183589011120266,
            lng: 106.93812701720795,
          },
          {
            name: 'BEKASI',
            lat: -6.183960505985163,
            lng: 106.94121138014256,
          },
          {
            name: 'KELAPA GADING',
            lat: -6.155617353205415,
            lng: 106.8968771758425,
          },
        ];

        const arrMarker: any = [];

        dataMarkers.forEach(({ name, lat, lng }) => {
          const hasMarker = isWordsIncludesVal(`${asal}-${tujuan}`, name);
          if (hasMarker) {
            const marker = new mapsState.maps.Marker({
              position: {
                lat,
                lng,
              },
              map: mapsState.map,
              title: name,
            });
            arrMarker.push(marker);
          }
        });

        setMarkerState(arrMarker);
      }
    },

    handleReset() {
      if (polylineState) {
        const resetPolyline = polylineState.setMap(null);
        setPolylineState(resetPolyline);
      }
      if (markerState[0] !== undefined) {
        const resetMarker = markerState.map((row: any) => row.setMap(null));
        setMarkerState(resetMarker);
      }
    },
  }));

  const onMapLoaded = (map: any, maps: any) => {
    setMapsState({
      mapsLoaded: true,
      map: map,
      maps: maps,
    });
  };

  return (
    <div className={classes.root}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: 'AIzaSyC2y1Qoj348lLHL7zqfMmGpB11g_1n8cdE' }}
        defaultCenter={{
          lat: -6.16771888217247,
          lng: 106.91775813648466,
        }}
        defaultZoom={12}
        yesIWantToUseGoogleMapApiInternals
        onGoogleApiLoaded={({ map, maps }) => onMapLoaded(map, maps)}
      />
    </div>
  );
});

export default Maps;
